<div class="skeleton-card">
  <div class="skeleton-img shimmer"></div>
  <div class="skeleton-line shimmer wide"></div>
  <div class="skeleton-line shimmer narrow"></div>
</div>
